/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './BancoDoAutoMotoBannerRCF.css';
import RedButton from '@/components/atoms/RedButton';

function BancoDoAutoMotoBannerRCF() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="banco-auto-25-banner">
        <div className="bg-hero">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 320 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/banco-do-auto25/hero-rcf/banner-320.png"
                  />
                  <img
                    src="assets/banco-do-auto25/hero-rcf/banner-320.png"
                    alt="Pessoa em moto em movimento em avenida a noite em cidade grande andando com tranquilidade pois com o financiamento no Santander teve seguro para terceiros grátis."
                    className=""
                  />
                </picture>
              )}
              {width > 320 && width <= 600 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/banco-do-auto25/hero-rcf/banner-450.png"
                  />
                  <img
                    src="assets/banco-do-auto25/hero-rcf/banner-450.png"
                    alt="Pessoa em moto em movimento em avenida a noite em cidade grande andando com tranquilidade pois com o financiamento no Santander teve seguro para terceiros grátis."
                    className=""
                  />
                </picture>
              )}
            </>
          )}
        </div>
        {/* <div className="fade-hero-santander" /> */}
        <ContainerHome24>
          <div className="bg-hero">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width > 600 && width <= 1280 && (
                  <picture>
                    <source
                      type="image/png"
                      srcSet="assets/banco-do-auto25/hero-rcf/banner-800.png"
                    />
                    <img
                      src="assets/banco-do-auto25/hero-rcf/banner-800.png"
                      alt="Pessoa em moto em movimento em avenida a noite em cidade grande andando com tranquilidade pois com o financiamento no Santander teve seguro para terceiros grátis."
                      className=""
                    />
                  </picture>
                )}
                {width > 1280 && (
                  <picture>
                    <source
                      type="image/png"
                      srcSet="assets/banco-do-auto25/hero-rcf/banner-1360.png"
                    />
                    <img
                      src="assets/banco-do-auto25/hero-rcf/banner-1360.png"
                      alt="Pessoa em moto em movimento em avenida a noite em cidade grande andando com tranquilidade pois com o financiamento no Santander teve seguro para terceiros grátis."
                      className=""
                    />
                  </picture>
                )}
              </>
            )}
          </div>
          <div className="hero-contain">
            <div className="hero-buttons">
              <WhiteButton
                href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=financiamento-de-moto:banner&int_campaign=simular-financiamento"
                target="_blank"
                rel="noopener"
                className="btn-simulate"
              >
                Quero Simular
              </WhiteButton>
              {/* <RedButton href="#santander-carousel" id="hero-button-outros-produtos">
                Produtos
              </RedButton> */}
            </div>
          </div>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default BancoDoAutoMotoBannerRCF;
